<template>

    <div class="container">

        <app-head title="Orders" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Bestellungen') }}</h1>
            <!--            <div class="">
                            <inertia-link :href="route('admin.orders.create', { })" class="btn btn-primary">
                                {{ __('Erstellen') }}
                            </inertia-link>
                        </div>-->
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
                <text-input type="date" label="from" v-model="form.from" />
                <text-input type="date" label="until" v-model="form.until" />
                <select-input label="order_status" v-model="form.order_status">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="k" v-for="(v, k) in orderStatusOptions">{{ v }}</option>
                </select-input>
                <div class="w-100"></div>
                <select-input label="supplier" v-model="form.supplier_id">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="supplier.id" v-for="supplier in suppliers">{{ supplier.short_name }}</option>
                </select-input>
                <select-input label="status" v-model="form.status">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option value="archived">{{ __('Archiviert') }}</option>
                    <option value="trashed">{{ __('Papierkorb') }}</option>
                </select-input>
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="orders.meta" />
            <div>
                <i class="bi bi-download"></i>
                {{ __('Export') }}
                <a :href="getExportUrl('xlsx')">
                    {{ __('XLSX') }}
                </a>
                /
                <a :href="getExportUrl('csv')">
                    {{ __('CSV') }}
                </a>
                /
                <a :href="getExportUrl('ods')">
                    {{ __('ODS') }}
                </a>
            </div>
        </div>

        <div class="card">
            <data-table :items="orders.data"
                        :links="orders.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="order in orders.data" :key="order.id" :class="{'table-success': order.order_status === 'new'}">
                    <td>
                        <inertia-link class="fw-bold link-dark" :href="route('admin.orders.edit', order)">
                            {{ order.supplier_order_number }}
                        </inertia-link>
                    </td>
                    <td>
                        {{ order.order_date | localizeDateTime }}
                    </td>
                    <td>
                        {{ order.supplier.short_name }}
                    </td>
                    <td>
                        {{ order.customer.name }}
                    </td>
                    <td>
                        {{ order.customer.customer_number || '-' }}
                    </td>
                    <td>
                        <span class="badge bg-primary" v-if="order.order_status === 'new'">{{ __('Neu') }}</span>
                        <span class="badge bg-warning" v-if="order.order_status === 'pending_payment'">{{ __('Zahlung ausstehend') }}</span>
                        <span class="badge bg-success" v-if="order.order_status === 'confirmed'">{{ __('Bestätigt') }}</span>
                        <span class="badge bg-info" v-if="order.order_status === 'processing'">{{ __('In Bearbeitung') }}</span>
                        <span class="badge bg-danger" v-if="order.order_status === 'on_hold'">{{ __('Wartend') }}</span>
                        <span class="badge bg-secondary" v-if="order.order_status === 'completed'">{{ __('Abgeschlossen') }}</span>
                        <span class="badge bg-light" v-if="order.order_status === 'cancelled'">{{ __('Storniert') }}</span>
                        <span class="badge bg-dark" v-if="order.order_status === 'refunded'">{{ __('Zahlung erstattet') }}</span>
                        <span class="badge bg-danger" v-if="order.order_status === 'failed'">{{ __('Fehlgeschlagen') }}</span>
                    </td>
                    <td class="text-nowrap">
                        <boolean :value="order.shipped" />
                        <span v-if="order.shipping_date">
                            {{ order.shipping_date | localizeDateTime }}
                        </span>
                    </td>
                    <td class="text-nowrap">
                        <div class="fw-bold">
                            {{ order.subtotal | localizeAmount }}
                        </div>
                        <div class="small text-secondary">
                            {{ order.delivery | localizeAmount }} {{ __('Versand') }}
                        </div>
                        <div class="small">
                            {{ order.total | localizeAmount }} {{ __('Brutto') }}
                        </div>
                    </td>
                    <td class="text-end py-0 text-nowrap">

                        <template v-if="order.deleted_at">
                            <button type="button" class="btn btn-outline-success" @click="restore(order)">
                                {{ __('Restore') }}
                            </button>
                            <button type="button" class="btn btn-outline-danger" @click="destroyPermanently(order)">
                                {{ __('Destroy permanently') }}
                            </button>
                        </template>
                        <div class="dropdown" v-else>
                            <button class="btn btn-outline-secondary" 
                                    type="button" 
                                    :id="`dropdownMenuOrder-${order.id}`" 
                                    :title="__('Edit')"
                                    data-bs-toggle="dropdown" 
                                    aria-expanded="false">
                                <i class="bi bi-three-dots-vertical"></i>
                                {{ __('Edit') }}
                            </button>
                            <div class="dropdown-menu dropdown-menu-end" :aria-labelledby="`dropdownMenuOrder-${order.id}`">

                                <inertia-link :href="route('admin.orders.edit', {order})"  class="dropdown-item">
                                    {{ __('Bearbeiten') }}
                                </inertia-link>

                                <a :href="route('admin.orders.opentrans', {order})"  class="dropdown-item">
                                    {{ __('openTRANS-XML') }}
                                </a>

                                <inertia-link :href="route('admin.orders.update-order-status', {order, status: 'confirmed'})" 
                                              class="dropdown-item" 
                                              as="button"
                                              type="button"
                                              v-if="order.order_status === 'new' ">
                                    {{ __('Bestätigen') }}
                                    <span class="text-muted">
                                        ({{ __('Sendet eine Bestellbestätigung an den Kunden.') }})
                                    </span>
                                </inertia-link>
                                <inertia-link :href="route('admin.orders.send-confirmation-mail', {order})" 
                                              class="dropdown-item" 
                                              as="button"
                                              type="button"
                                              v-else>
                                    {{ __('Bestellbestätigung erneut an Kunde senden') }}
                                </inertia-link>

                                <template v-if="order.order_status !== 'completed' ">
                                    <inertia-link :href="route('admin.orders.update-order-status', {order, status: 'completed'})" 
                                                  class="dropdown-item" 
                                                  as="button"
                                                  type="button">
                                        {{ __('Abschließen') }}
                                    </inertia-link>
                                </template>
                                <inertia-link :href="route('admin.orders.send-supplier-mail', {order})" 
                                              class="dropdown-item" 
                                              as="button"
                                              type="button">
                                    {{ __('Bestelleingangsmail erneut an Lieferanten senden') }}
                                </inertia-link>
                                <!--                                <inertia-link :href="route('admin.orders.send-customer-mail', {order})" 
                                                                              class="dropdown-item" 
                                                                              as="button"
                                                                              type="button">
                                                                    {{ __('Bestellmail erneut an Kunde senden') }}
                                                                </inertia-link>-->
                            </div>
                        </div>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import SearchFilter from '@/shared/Admin/SearchFilter';
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';

    import Results from '@/shared/Admin/Results';
    import Boolean from '@/shared/Admin/Boolean';

    export default {
        props: [
            'filters',
            'orders',
            'suppliers',
            'orderStatusOptions',
        ],
        created() {
            // @todo laravel echo https://twitter.com/marcelpociot/status/1427730722542981124?s=20
//            setInterval(this.reloadPage, 10000);
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    status: this.filters.status,
                    supplier_id: this.filters.supplier_id,
                    from: this.filters.from,
                    until: this.filters.until,
                    order_status: this.filters.order_status,
                },
                columns: {
                    supplier_order_number: {label: 'Order number', sortable: 'supplier_order_number'},
                    order_date: {label: 'Date', sortable: 'order_date'},
                    supplier: {label: 'Supplier', sortable: 'supplier'},
                    customer: {label: 'Customer', sortable: 'customer.name'},
                    customer_number: {label: 'Customer Number', sortable: 'customer.customer_number'},
                    order_status: {label: 'Status', sortable: 'order_status'},
                    shipped: {label: 'Versandt', sortable: 'shipped'},
                    subtotal: {label: 'Betrag', sortable: 'subtotal'},
                },
            }
        },
        components: {
            SearchFilter,
            SelectInput,
            TextInput,
            DataTable,
            DataTableRow,
            Results,
            Boolean,
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.orders.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
            reloadPage() {
                this.$inertia.reload({preserveScroll: true});
            },
            destroyPermanently(order) {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.orders.destroy-permanently', order.id));
                }
            },
            restore(order) {
                this.$inertia.get(this.route('admin.orders.restore', order.id));
            },
            getExportUrl(format) {
                return this.route('admin.orders.export', {format: format, ...this.filters});
            }
        },
    }
</script>